module.exports = __webpack_public_path__ + "media/images/icons/checkmark-white-74bf54b9fa870a548e4a2d9b987ecbbf.svg";